const mobileMaxWidth = 768;
const originalParents = new Map();
const originalState = new Map();

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector('.product-add-to-cart-sticky');
  if (el) {
    el.classList.add('show');
    manageAddToCartSticky();
  }

  // Move sections on left side if desktop
  manageMobileSections();

  // Move wishlist button next to addToCart
  moveWishlistButton();

  // info modal close
  const overlay = document.getElementById("custom-overlay");
  if (overlay) {
    overlay.addEventListener("click", function () {
      closeCustomModal();
    });
  }

  // Questions & Answers
  const qaDiv = document.querySelector('.qaQuestions');
  if (qaDiv) {
    qaDiv.addEventListener('click', function (e) {
      const question = e.target.closest('.qaQuestionText');
      if (!question) return;
      const answers = question
        .closest('li')
        .querySelector('.qaAnswers');
      if (answers) {
        answers.style.display =
          answers.style.display === 'block'
            ? 'none'
            : 'block';
      }
    });
  }
});

function moveWishlistButton() {
  const el = document.querySelector('xb-wishlist-button');
  const buyContainer = document.querySelector('.buy-container');
  if (el && buyContainer) {
    buyContainer.prepend(el);
  }
}

window.addEventListener('resize', () => {
  manageAddToCartSticky();
  manageMobileSections();
});

window.addEventListener("scroll", function () {
  const el = document.querySelector('.product-add-to-cart-sticky');
  if (window.scrollY === 0 && el) {
    el.classList.add('custom-show');
  } else {
    el.classList.remove('custom-show');
  }
});

function manageAddToCartSticky() {
  const el = document.querySelector('.product-add-to-cart-sticky');
  const sticky = el.querySelector('.product-details-sticky');
  if (sticky) {
    const pds = sticky.querySelectorAll(':scope > :nth-child(-n+2)');

    if (window.innerWidth > mobileMaxWidth) {
      pds.forEach(el => el.classList.remove('hidden-content'));
    } else {
      pds.forEach(el => el.classList.add('hidden-content'));
    }
  }
}

function manageMobileSections() {
  const isMobile = window.innerWidth < mobileMaxWidth;
  if (!isMobile) {
    moveSectionsOnLeftSide();
  } else {
    resetSectionsPosition();
  }
}

function moveSectionsOnLeftSide() {
  const isMobile = window.innerWidth < mobileMaxWidth;

  if (!isMobile) {
    document
      .querySelector('[id*="MediaGallery"]')
      ?.classList.remove('product__column-sticky');

    const target = document.querySelector('.product__media-wrapper');

    const keywords = [
      'rich_text',
      'collapsible_content',
      'technologies',
      'activities',
      'performances',
      'product-details',
      'image_with_text_overlay_BmrJA7',
      'q-e-a',
      'feedaty-reviews',
      'product_form',
      '17818792827b71d2ff',
      '17933523046b7fd538',
    ];

    const sections = document.querySelectorAll('.shopify-section');

    sections.forEach(section => {
      const id = section.id || '';
      const match = keywords.some(keyword => id.includes(keyword));

      if (match) {
        // save original element position one time
        if (!originalState.has(section)) {
          originalState.set(section, {
            parent: section.parentNode,
            next: section.nextSibling
          });
        }

        target.appendChild(section);
      }
    });
  }
}

function resetSectionsPosition() {
  const mediaGallery = document.querySelector('[id*="MediaGallery"]');
  mediaGallery?.classList.add('product__column-sticky');

  // reset original order
  originalState.forEach((state, section) => {
    state.parent.insertBefore(section, state.next);
  });
}

function openCustomModal(title, text) {
  const modal = document.getElementById("custom-modal");
  const overlay = document.getElementById("custom-overlay");

  document.getElementById("custom-modal-title").innerHTML = title;
  document.getElementById("custom-modal-text").innerHTML = text;

  modal.classList.remove("hidden-content");
  overlay.classList.remove("hidden-content");
}

function closeCustomModal() {
  document.getElementById("custom-modal").classList.add("hidden-content");
  document.getElementById("custom-overlay").classList.add("hidden-content");
}